import React from 'react';
import { Link } from 'react-router-dom';

const FooterGreen = () => {
    return (
        <footer className="bg-black text-green-600 py-12 px-4">
            <div className="max-w-7xl mx-auto">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
                    <div>
                        <h3 className="text-xl font-bold text-white mb-4 pb-2 border-b-2 border-green-600 inline-block">FLEETY
                        </h3>
                        <ul className="space-y-2">
                            <li>
                                <Link to="/about-us" className="text-gray-400 hover:text-green-600 transition">
                                    About Us
                                </Link>
                            </li>
                            <li>
                                <Link to="/contact-us" className="text-gray-400 hover:text-green-600 transition">Contact Us
                                </Link>
                            </li>
                            <li>
                                <Link to="/truckers-forum" className="text-gray-400 hover:text-green-600 transition">Trucker
                                    Forum</Link>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <h3 className="text-xl font-bold text-white mb-4 pb-2 border-b-2 border-green-600 inline-block">CARRIERS
                        </h3>
                        <ul className="space-y-2">
                            <li>
                                <Link to="/carrier-registration" className="text-gray-400 hover:text-green-600 transition">
                                    Carrier Registration</Link>
                            </li>
                            <li>
                                <Link to="/carrier-login" className="text-gray-400 hover:text-green-600 transition">Carrier Login
                                </Link>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <h3 className="text-xl font-bold text-white mb-4 pb-2 border-b-2 border-green-600 inline-block">Get in
                            Touch</h3>
                        <ul className="space-y-2">
                            {/* <li className="text-gray-400">Mexico</li> */}
                            {/* <li className="text-gray-400">+1 245 640 00</li> */}
                            <li className="text-gray-400">support@fleety.com</li>
                            <li className="text-gray-400">Mon - Fri: 9:00 AM - 6:00 PM</li>
                        </ul>
                    </div>

                    <div>
                        <h3 className="text-xl font-bold text-white mb-4 pb-2 border-b-2 border-green-600 inline-block">FLEETY'S
                            NEWSLETTER</h3>
                        <div className="space-y-3">
                            <input type="email" placeholder="Email"
                                className="w-full p-3 border-2 border-green-600 rounded bg-transparent text-white" />
                            <button
                                className="w-full bg-green-600 text-black font-bold py-3 rounded hover:bg-green-700 transition">
                                Sign Up
                            </button>
                        </div>
                        <p className="text-gray-400 text-sm mt-4">
                            I agree to receive emails from Fleety.com. I understand that I can unsubscribe at any time. By
                            clicking on "Sign Up", you agree to our Terms of Use and Privacy Policy.
                        </p>
                    </div>
                </div>

                <div
                    className="border-t border-gray-800 mt-10 pt-6 text-gray-400 text-sm flex flex-col md:flex-row justify-between items-center">
                    <p>Copyright © 2025 Fleety. All rights reserved <a href="#" className="text-green-600 hover:underline">Site
                        Map</a></p>
                    <p className="mt-2 md:mt-0">
                        <a href="#" className="text-green-600 hover:underline mx-2">Terms of Use</a> |
                        <a href="#" className="text-green-600 hover:underline mx-2">Privacy Policy</a> and
                        <a href="#" className="text-green-600 hover:underline mx-2">Cookie Policy</a>
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default FooterGreen;